// extracted by mini-css-extract-plugin
export default {"conversation-header":"conversation-header__Z2XW7vUyRVHi"};